import { IUpdateAuditoriaUseCase } from "../../../presentation/useCases/update/update_auditoria_servicos_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

export class UpdateAuditoriaUseCase implements IUpdateAuditoriaUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async updateAuditoria(
    IdAuditoria: number,
    Evento: string | null,
    TipoAuditoria: number | null,
    EmAberto: boolean | null,
    DataElaboracao: Date | null,
    DataAuditoria: Date | null,
    DataTermino: Date | null,
    Criterio: string | null,
    Observacao: string | null,
    IdAuditor1: number | null,
    IdAuditor2: number | null,
    IdAuditor3: number | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    nomeArquivo1: string | null,
    nomeArquivo2: string | null,
    limparArquivo1: boolean,
    limparArquivo2: boolean
  ): Promise<void> {
    await this.repository.updateAuditoria(
      IdAuditoria,
      Evento,
      TipoAuditoria,
      EmAberto,
      DataElaboracao,
      DataAuditoria,
      DataTermino,
      Criterio,
      Observacao,
      IdAuditor1,
      IdAuditor2,
      IdAuditor3,
      Arquivo1,
      Arquivo2,
      nomeArquivo1,
      nomeArquivo2,
      limparArquivo1,
      limparArquivo2
    );
  }
}
